import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import {
  addFabricaSinProveedor,
  getFabricasTipo,
} from "../../api/ProveedoresyFabricas/fabricasApi"; // ✅ Nuevo endpoint

const FabricasAdd = ({ open, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    NombreFabrica: "",
    Direccion: "",
    Pais: "",
    Telefono: "",
    Email: "",
    Notas: "",
    id_FabricaTipo: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (!formData.NombreFabrica.trim()) return;
    try {
      await addFabricaSinProveedor(formData); // ✅ Usamos el nuevo endpoint
      onSave();
      onClose();
      setFormData({
        NombreFabrica: "",
        Direccion: "",
        Pais: "",
        Telefono: "",
        Email: "",
        Notas: "",
        id_FabricaTipo: "",
      }); // Reset
    } catch (error) {
      console.error("❌ Error al añadir fábrica:", error);
    }
  };

  const [tiposFabrica, setTiposFabrica] = useState([]);

  useEffect(() => {
    const fetchTipos = async () => {
      const tipos = await getFabricasTipo();
      setTiposFabrica(tipos);
    };
    fetchTipos();
  }, []);

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 400, p: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ color: "#90b2b7", fontWeight: 800 }}>
            Add Factory
          </Typography>
          <IconButton
            sx={{
              border: "1px solid #90b2b7",
              backgroundColor: "#fff",
              color: "#90b2b7",
              padding: "5px",
              "&:hover": { backgroundColor: "#90b2b7", color: "#fff" },
            }}
            onClick={onClose}
          >
            <Close />
          </IconButton>
        </Box>

        <TextField
          label="Factory Name *"
          name="NombreFabrica"
          value={formData.NombreFabrica}
          onChange={handleChange}
          fullWidth
          sx={{ my: 1 }}
          required
        />

        <TextField
          label="Address"
          name="Direccion"
          value={formData.Direccion}
          onChange={handleChange}
          fullWidth
          sx={{ my: 1 }}
        />

        <TextField
          label="Country"
          name="Pais"
          value={formData.Pais}
          onChange={handleChange}
          fullWidth
          sx={{ my: 1 }}
        />

        <TextField
          label="Phone"
          name="Telefono"
          value={formData.Telefono}
          onChange={handleChange}
          fullWidth
          sx={{ my: 1 }}
        />

        <TextField
          label="Email"
          name="Email"
          value={formData.Email}
          onChange={handleChange}
          fullWidth
          sx={{ my: 1 }}
        />
        <TextField
          label="Notas"
          name="Notas"
          value={formData.Notas}
          onChange={handleChange}
          fullWidth
          multiline
          minRows={3} // Altura mínima
          maxRows={10} // Altura máxima antes de hacer scroll
          sx={{ my: 1 }}
        />
        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel>Factory Type</InputLabel>
          <Select
            name="id_FabricaTipo"
            value={formData.id_FabricaTipo}
            onChange={(e) =>
              setFormData({ ...formData, id_FabricaTipo: e.target.value })
            }
          >
            {tiposFabrica.map((tipo) => (
              <MenuItem key={tipo.id_FabricaTipo} value={tipo.id_FabricaTipo}>
                {tipo.NombreTipo}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 2, backgroundColor: "#90b2b7", color: "#000" }}
          onClick={handleSave}
        >
          Save Factory
        </Button>
      </Box>
    </Drawer>
  );
};

export default FabricasAdd;
